import { StandardFilter, Filter, RadioFilter } from "./types";
import { Article, valueArray } from "..";

function applyFilter(filter: Filter, article: Article): boolean {
  const values = valueArray(article.data[filter.column]);
  if (filter.value.length === 0) {
    return true;
  } else if (filter.containAll) {
    return filter.value.every((value) => values.includes(value));
  } else {
    return filter.value.some((value) => values.includes(value));
  }
}

export function applyFilters(
  filters: Array<Filter>,
  articles: Array<Article>
): Array<Article> {
  return articles.filter((article) =>
    filters.every((filter): boolean => applyFilter(filter, article))
  );
}

export function initStandardFilter(
  column: string,
  options: Array<string>
): StandardFilter {
  return {
    type: "Standard",
    column,
    options: options.map((value) => ({ label: value, value })),
    value: [],
    containAll: false,
  };
}

export function initRadioFilter(
  initialOn: boolean,
  column: string,
  options: Array<string>
): RadioFilter {
  return {
    type: `Radio`,
    column,
    options: options.map((value) => ({ label: value, value })),
    value: initialOn ? [...options] : [],
    containAll: false,
  };
}
